import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';

export function getAllWorkstations() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLWORKSTATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getDataByWorkstationId(id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETDATABYWORKSTATION);
    url += `?workstationId=${id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getPalletDataBySSCC(sscc) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPALLETDATABYSSCC);
    url += `?sscc=${sscc}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getActiveProductionOrders(workstationId, userId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETACTIVEPRODUCTIONORDERS);
    url += `?workstationId=${workstationId}`;
    url += `&userId=` + userId;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getActiveProductionOrdersByProduct(productCode, workstationId, userId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETACTIVEPRODUCTIONORDERSBYPRODUCT);
    url += `?productCode=${productCode}`;
    url += `&workstationId=${workstationId}`;
    url += `&userId=` + userId;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getEventHistory() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETEVENTHISTORY);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });

}

export function getPrintHistory() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRINTHISTORY);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getLatestNotifications() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLATESTNOTIFICATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
